import Vue from "vue";

/* eslint-disable-next-line */
interface HTMLElement {
  clickOutsideEvent: () => void;
}

Vue.directive("click-outside", {
  /* eslint-disable */
  bind: function (el: any, binding: any, vnode: any) {
    (el as any).clickOutsideEvent = (event: any) => {
      // Check that click was outside the el and its children
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el: any) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
  /* eslint-enable */
});
